import { LIMIT_REACHED_ERROR_CODE } from '../constants';

export function isLimitReachedRejection(
  errors?: { errorCode: string | null }[]
): boolean {
  return errors?.some((e) => e.errorCode === LIMIT_REACHED_ERROR_CODE) ?? false;
}

// One reason, but the field is a list. Take the first code that's set.
export function rejectionCode(
  errors?: { errorCode: string | null }[]
): string | null {
  return errors?.find((e) => e.errorCode)?.errorCode ?? null;
}
